import {
	Tracker,
	TrackingEvent,
	TrackerLogger,
	TrackerHandles,
} from '../Tracking.events';

export class PlausibleTracker implements Tracker {
	plausible: NonNullable<TrackerHandles['plausible']>;
	constructor(plausible: NonNullable<TrackerHandles['plausible']>) {
		this.plausible = plausible;
	}

	sendEvent(event: TrackingEvent) {
		const { type } = event;
		TrackerLogger.debug(`Plausible: `, event);
		this.plausible.trackEvent(type);
	}
}
